export default __webpack_public_path__ + "static/maps-48346dfe30707e6a7e87fffdc19f5e85.jpg";